import React, { FC, useEffect, useState } from 'react';
import { User } from '../../interfaces/User';
import { DefaultInput } from '../general/forms/DefaultInput';
import { DropDown } from '../general/forms/DropDown';
import { TextBox } from '../general/forms/TextBox';
import { SelectBox } from '../general/forms/SelectBox';
import { LinkButton } from '../general/LinkButton';
import { useShowAlertPopup } from '../../state/hooks/AlertHooks';
import { FormHeadline, FormWrapper, FormContainer, FormFieldset, FormButtonWrapper } from './Layouts';
import { CustomerTypes } from '../../utils/CustomerTypes';

export interface UserFromValidationState {
  email: boolean;
  phone: boolean;
  role: boolean;
  customerTypes: boolean;
  emailSignature: boolean;
  dewDepartment: boolean;
  firstName: boolean;
  familyName: boolean;
  password: boolean;
}

interface Props {
  user?: User;
  setUser: (user: User) => void;
  onCancelClick?: () => void;
}
export const UserSettingsForm: FC<Props> = (props) => {
  const { user = null, setUser, onCancelClick } = props;
  const showNotificationBanner = useShowAlertPopup();
  const [tempUser, setTempUser] = useState<User | null>(user);

  useEffect(() => setTempUser(user), [user]);

  const [validationState, setValidationState] = useState<UserFromValidationState>({
    customerTypes: false,
    dewDepartment: false,
    email: false,
    emailSignature: false,
    familyName: false,
    firstName: false,
    password: false,
    phone: false,
    role: false,
  });

  const validate = () => {
    const state = {
      emailSignature: (tempUser?.emailSignature && tempUser?.emailSignature.length > 0) ? false : true,
      customerTypes: (tempUser?.customerTypes && tempUser?.customerTypes?.length > 0) ? false : true,
      dewDepartment: (tempUser?.dewDepartment && tempUser?.dewDepartment.length > 0) ? false : true,
      email: (tempUser?.email && tempUser?.email.length > 0) ? false : true,
      familyName: (tempUser?.familyName && tempUser?.familyName.length > 0) ? false : true,
      firstName: (tempUser?.firstName && tempUser?.firstName.length > 0) ? false : true,
      password: user !== null ? false : (tempUser && tempUser.password && tempUser.password.length > 0 ? false : true),
      phone: (tempUser?.phone && tempUser?.phone.length > 0) ? false : true,
      role: (tempUser?.role && tempUser?.role === 0 || 1 || 2) ? false : true,
    };
    setValidationState(state);
    return state;
  };

  return (
    <>
      <FormHeadline>Benutzereinstellungen</FormHeadline>
      <FormWrapper>
        <FormContainer>

          <FormFieldset>
            <FormHeadline>Stammdaten</FormHeadline>
            <DefaultInput
              id={'fistName'}
              onChange={(event) => {
                setTempUser({ ...tempUser, firstName: event.target.value });
              }}
              type={'text'}
              label={'Vorname'}
              placeholder={'Vorname'}
              value={tempUser?.firstName}
              required={true}
              hasError={validationState.firstName} />
            <DefaultInput
              id={'familyName'}
              onChange={(event) => {
                setTempUser({ ...tempUser, familyName: event.target.value });
              }}
              type={'text'}
              label={'Nachname'}
              placeholder={'Nachname'}
              value={tempUser?.familyName}
              required={true}
              hasError={validationState.familyName} />

            {
              // show password field only for new users
            }
            <DefaultInput
              id={'phone'}
              onChange={(event) => {
                setTempUser({ ...tempUser, phone: event.target.value });
              }}
              type={'text'}
              label={'Telefon'}
              placeholder={'+49123456789'}
              value={tempUser?.phone}
              required={true}
              hasError={validationState.phone} />
            <TextBox
              id={'email-signature'}
              onChange={(event) => {
                setTempUser({ ...tempUser, emailSignature: event.target.value });
              }}
              label={'E-Mail Signature'}
              placeholder={''}
              value={tempUser?.emailSignature}
              required={true}
              hasError={validationState.emailSignature} />
          </FormFieldset>

          <FormFieldset>
            <FormHeadline>Unveränderliche Daten</FormHeadline>
            <DefaultInput
              id={'email'}
              onChange={(event) => {
                setTempUser({ ...tempUser, email: event.target.value });
              }}
              type={'text'}
              label={'E-Mail'}
              disabled
              placeholder={'max.mustermann@dew21.de'}
              value={tempUser?.email}
              required={true}
              hasError={validationState.email} />
            {/* <DefaultInput
              id={'dew-department'}
              onChange={(event) => {
                setTempUser({ ...tempUser, dewDepartment: event.target.value });
              }}
              type={'text'}
              label={'Abteilung'}
              placeholder={''}
              disabled
              value={tempUser?.dewDepartment}
              required={true}
              hasError={validationState.dewDepartment} />
            <DropDown
              id={'role'}
              onChange={(event) => {
                setTempUser({ ...tempUser, role: parseInt(event.target.selectedOptions[0].value) });
              }}
              type={'text'}
              label={'Rolle'}
              disabled
              value={tempUser?.role}
              required={true}
              hasError={validationState.role}
              options={[
                { key: 0, value: 'Administrator' },
                { key: 1, value: 'Vertriebsleiter' },
                { key: 2, value: 'Vertriebsmitarbeiter' },
              ]} />
            <SelectBox
              multi={true}
              id={'customer-types'}
              disabled
              onChange={(data: string[]) => {
                setTempUser({ ...tempUser, customerTypes: data });
              }}
              label={'Kundentarten'}
              value={tempUser?.customerTypes || []}
              options={[
                { key: CustomerTypes.BUSINESS, value: 'Gewerbekunde', icon: 'customers-commercial' },
                { key: CustomerTypes.HOUSING_INDUSTRY, value: 'Vertriebsleiter', icon: 'customers-housing' },
                { key: CustomerTypes.MAJOR_CUSTOMERS, value: 'Vertriebsmitarbeiter', icon: 'customers-major' },
              ]}
              required={true}
              hasError={validationState.customerTypes} /> */}
          </FormFieldset>

          <FormButtonWrapper>
            <LinkButton onChangeHandler={(event: React.FormEvent<HTMLButtonElement>) => {
              setTempUser(user);
              if (onCancelClick) {
                onCancelClick();
              }
            }}>Abbrechen</LinkButton>
            <LinkButton onChangeHandler={(event: React.FormEvent<HTMLButtonElement>) => {
              const validations = validate();
              const inValid = Object.keys(validations).map((key) => {
                return validations[key];
              }).filter(Boolean).length > 0;

              if (!inValid) {
                setUser(tempUser);
              } else {
                showNotificationBanner({
                  error: true,
                  renderContent: () => {
                    return <>Bitte füllen Sie alle Rot markierten Felder aus.</>;
                  },
                },
                );
              }
            }}>Änderungen speichern</LinkButton>
          </FormButtonWrapper>

        </FormContainer>
      </FormWrapper>
    </>
  );
};
